module.exports = __webpack_public_path__ + "static/media/confetti.878ae403.gif";